import { render, staticRenderFns } from "./ByCustomerTab.vue?vue&type=template&id=6e422a9c&scoped=true"
import script from "./ByCustomerTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ByCustomerTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ByCustomerTab.vue?vue&type=style&index=0&id=6e422a9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e422a9c",
  null
  
)

export default component.exports